module.exports = __webpack_public_path__ + "img/chat-bg-fill.7bf9d118.svg";